import React, {
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import styles from "./repo.module.scss";
import {
  Button,
  GetProps,
  Input,
  Space,
  Spin,
  Splitter,
  Switch,
  Tooltip,
  Tree,
} from "antd";
import {
  ArrowUpOutlined,
  CloseOutlined,
  CommentOutlined,
  DownOutlined,
  EnterOutlined,
  LoadingOutlined,
  ReadOutlined,
  RetweetOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import { findNodeByPath, reMadeTree, TreeData } from "../../utils/util";
import http from "../../http";
import { CodeBlock, dracula } from "react-code-blocks";
import { SuffixCorrespondencemap } from "../../utils/SuffixCorrespondencemap";
import { useTheme } from "../../context/ThemeContext";
import { getCodeContent, getRepoMenu } from "../api/chat";
import Editor from "@monaco-editor/react";
import { loader } from "@monaco-editor/react";
import { editor } from "monaco-editor";
import { debounce, set } from "lodash";
import { useThread } from "../../pages";
export interface selectData {
  filepath: string;
  filename: string;
  startLineNumber: Number;
  endLineNumber: Number;
}
function Index(
  props: {
    repoData: {
      repo_full_name: string;
      branch_name: string;
      type: string;
    };
    isAnswer: boolean;
    close: () => void;
    onQuote: (selectData: selectData, askStr?: string) => void;
  },
  ref: any
) {
  const { DirectoryTree } = Tree;
  const { thread_id } = useThread();
  const { repoData, isAnswer, close, onQuote } = props;
  const [selectNode, setselectNode] = useState<any[]>([]);
  const [text, setText] = useState("");
  const [language, setLanguage] = useState("txt");
  const [treeData, setTreeData] = useState<TreeData[]>([]);
  const [loading, setLoading] = useState(false);
  const [codeLoading, setCodeLoading] = useState(false);
  const { theme, toggleTheme } = useTheme();
  const [title, setTitle] = useState("");
  const [wrap, setWrap] = useState<"on" | "off">(
    (localStorage.getItem("wrap") as "on" | "off") || "on"
  );
  const menuRef = useRef<HTMLDivElement>(null);

  const [height, setHeight] = useState(800);
  const [expandedKeys, setExpandedKeys] = useState<string[]>([]);
  const sNodeData = useRef({
    fileName: "",
    filePath: "",
  });
  const mEditor = useRef<editor.IStandaloneCodeEditor>();
  const highlightRef = useRef<{ startLine?: number; endLine?: number }>({});
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [askVisible, setAskVisible] = useState(false);
  const [askValue, setAskValue] = useState("");
  const [monacoReady, setMonacoReady] = useState(false);
  useEffect(() => {
    loader.config({
      paths: { vs: "/monaco/vs" },
      "vs/nls": { availableLanguages: { "*": "zh-cn" } },
    });
    loader
      .init()
      .then(() => setMonacoReady(true))
      .catch(() => setMonacoReady(false));
  }, []);
  useEffect(() => {
    if (treeData.length && !selectNode.length) {
      sleectDefultNode(treeData);
    }
    if (menuRef.current) {
      setHeight(menuRef.current?.clientHeight - 20 || 800);
    }
  }, [treeData]);

  const sleectDefultNode = (treeData: TreeData[]) => {
    const README = treeData.some((item) => item.path === "README.md");
    if (README) {
      setselectNode(["README.md"]);
      setTitle("README.md");
      sNodeData.current = {
        fileName: "README.md",
        filePath: "README.md",
      };
      highlightRef.current = {};
      getCode(
        "README.md",
        repoData.branch_name,
        repoData.repo_full_name,
        repoData.type
      );
    } else {
      const firstFile = treeData.find((item) => item.isLeaf);
      if (firstFile) {
        setselectNode([firstFile?.path]);
        setTitle(firstFile.title);
        sNodeData.current = {
          fileName: firstFile.title,
          filePath: firstFile?.path,
        };
        highlightRef.current = {};
        getCode(
          firstFile?.path,
          repoData.branch_name,
          repoData.repo_full_name,
          repoData.type
        );
      }
    }
  };
  const onSelect = (selectedKeysValue: any[], info: any) => {
    if (info.node.isLeaf) {
      setselectNode(selectedKeysValue);
      setTitle(info.node.title);
      sNodeData.current = {
        fileName: info.node.title,
        filePath: selectedKeysValue[0],
      };
      highlightRef.current = {};
      getCode(
        selectedKeysValue[0],
        repoData.branch_name,
        repoData.repo_full_name,
        repoData.type
      );
    }
  };

  const getCode = (
    path: string,
    branch_name: string,
    repo_full_name: string,
    type: string
  ) => {
    setCodeLoading(true);
    getCodeContent({
      thread_id,
      repo_full_name,
      branch_name,
      type,
      file_path: path,
    }).then((data: any) => {
      if (data.status) {
        const suffix =
          SuffixCorrespondencemap[(path.split(".") || []).at(-1) || ""] ||
          "txt";
        setLanguage(suffix);
        mEditor.current?.setScrollTop(0);
        mEditor.current?.setScrollLeft(0);
        setText(data.data?.content || "");
        setLoading(false);
        setCodeLoading(false);
        setTimeout(() => {
          applyHighlight();
        }, 300);
      }
    });
  };
  const getTree = (props: {
    repo_full_name: string;
    branch_name: string;
    type: string;
    file_path?: string;
  }) => {
    const { repo_full_name, branch_name, type, file_path = "" } = props;
    if (
      treeData.length &&
      repo_full_name === repoData.repo_full_name &&
      branch_name === repoData.branch_name
    ) {
      return;
    }
    setselectNode([]);
    setLoading(true);
    getRepoMenu({ thread_id, repo_full_name, branch_name, type, file_path })
      .then((res) => {
        const tree = reMadeTree(res.data?.data || []);
        setTreeData(tree);
        if (file_path) {
          const titleName = (file_path.split("/") || []).reverse()[0] || "";
          setselectNode([file_path]);
          setTitle(titleName);
          sNodeData.current = {
            fileName: titleName,
            filePath: file_path,
          };
          getCode(file_path, branch_name, repo_full_name, type);
          expandToPath(file_path);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const expandToPath = async (filePath: string) => {
    if (!filePath || !filePath.includes("/")) return;
    const parts = filePath.split("/");
    const prefixes: string[] = [];
    for (let i = 1; i < parts.length; i++) {
      const prefix = parts.slice(0, i).join("/");
      prefixes.push(prefix);
      const node = findNodeByPath(treeData, prefix);
      if (node) {
        if (!Array.isArray(node.children) || node.children.length === 0) {
          try {
            const res = await getRepoMenu({
              thread_id,
              repo_full_name: repoData.repo_full_name,
              branch_name: repoData.branch_name,
              type: repoData.type,
              file_path: prefix,
            });
            const new_children = reMadeTree(res.data?.data || [], node.path);
            node.children = new_children;
            setTreeData([...treeData]);
          } catch (e) {}
        }
      }
    }
    setTimeout(() => {
      setExpandedKeys((prev) => Array.from(new Set([...prev, ...prefixes])));
    }, 300);
  };
  const onLoadData = ({ key, children }: any) => {
    return new Promise<void>((resolve, reject) => {
      if (children.length) {
        resolve();
        return;
      }
      getRepoMenu({ thread_id, ...repoData, file_path: key })
        .then((res) => {
          const node = findNodeByPath(treeData, key);
          if (node) {
            const new_tree = reMadeTree(res.data?.data || [], node?.path);
            node.children = new_tree;
            setTreeData([...treeData]);
          }
          resolve();
        })
        .catch((err) => {
          reject();
        });
    });
  };
  const onWrapChange = (checked: boolean) => {
    if (checked) {
      setWrap("on");
      localStorage.setItem("wrap", "on");
    } else {
      setWrap("off");
      localStorage.setItem("wrap", "off");
    }
  };
  const configureEditor = (monaco: any) => {
    // 配置TypeScript编译器选项
    monaco.languages?.typescript?.typescriptDefaults.setCompilerOptions({
      target: monaco.languages.typescript.ScriptTarget.ESNext,
      module: monaco.languages.typescript.ModuleKind.ESNext,
      moduleResolution: monaco.languages.typescript.ModuleResolutionKind.NodeJs,
      jsx: monaco.languages.typescript.JsxEmit.React,
      reactNamespace: "React",
      allowNonTsExtensions: true,
      allowJs: true,
      noEmit: true,
    });
  };
  const editorDidMount = useCallback(
    (editor: editor.IStandaloneCodeEditor, monaco: any) => {
      mEditor.current = editor;
      // 使用 debounce 包裹选择变化事件处理函数
      const handleSelectionChange = debounce((event) => {
        const selection = event.selection;
        const text = editor.getModel()?.getValueInRange(selection);
        if (!text) {
          // 如果没有选中内容，隐藏菜单
          setMenuVisible(false);
          setAskVisible(false);
          setAskValue("");
        } else {
          // 计算选中区域的位置
          const position = editor.getScrolledVisiblePosition(
            selection.getEndPosition()
          );
          const editorDomNode = editor.getDomNode();
          if (editorDomNode && position) {
            const top = position.top;
            let left = 0;
            if (editorDomNode.offsetWidth - position.left < 342) {
              left = editorDomNode.offsetWidth - 342;
            } else {
              left = position.left;
            }
            setMenuPosition({ top, left });
            setMenuVisible(true);
          }
        }
      }, 100); // 300 毫秒的防抖时间

      editor.onDidChangeCursorSelection(handleSelectionChange);
      // 清除防抖函数，防止内存泄漏
      return () => {
        handleSelectionChange.cancel();
      };
    },
    []
  );
  const applyHighlight = useCallback(() => {
    const start = highlightRef.current.startLine;
    const end = highlightRef.current.endLine;
    if (!mEditor.current || !start || !end) return;
    const model = mEditor.current.getModel();
    if (!model) return;
    const lineCount = model.getLineCount();
    let s = Math.max(1, Math.min(start, lineCount));
    let e = Math.max(1, Math.min(end, lineCount));
    if (s > e) {
      const t = s;
      s = e;
      e = t;
    }
    const endColumn = model.getLineMaxColumn(e);
    mEditor.current.setSelection({
      startLineNumber: s,
      startColumn: 1,
      endLineNumber: e,
      endColumn,
    });
    mEditor.current.revealLinesInCenter(s, e);
    mEditor.current.focus();
  }, []);
  const codeAsk = useCallback(
    (askStr?: string) => {
      const selection: any = mEditor.current!.getSelection();
      onQuote(
        {
          filepath: sNodeData.current.filePath,
          filename: sNodeData.current.fileName,
          startLineNumber: selection.startLineNumber,
          endLineNumber: selection.endLineNumber,
        },
        askStr
      );
    },
    [onQuote]
  );
  const handleAskClick = () => {
    setAskVisible(true);
  };
  const renderMenu = useMemo(
    () => (
      <div
        style={{
          position: "absolute",
          top: menuPosition.top,
          left: menuPosition.left,
          zIndex: 1000,
          display: menuVisible ? "block" : "none",
        }}
      >
        <div className={styles.btnMenu}>
          {!askVisible ? (
            <>
              <Button
                type="text"
                icon={<ReadOutlined />}
                disabled={isAnswer}
                onClick={() => codeAsk("解释这段代码")}
              >
                代码解释
              </Button>
              <Button
                type="text"
                icon={<ToolOutlined />}
                disabled={isAnswer}
                onClick={() => codeAsk("修复这段代码")}
              >
                代码修复
              </Button>
              <Button
                type="text"
                icon={<CommentOutlined />}
                disabled={isAnswer}
                onClick={handleAskClick}
              >
                问问Eagle
              </Button>
            </>
          ) : (
            <Space>
              <Input
                style={{ width: 260 }}
                value={askValue}
                placeholder="问问Eagle"
                onChange={(e) => {
                  setAskValue(e.target.value);
                }}
              />
              <Button
                type="primary"
                disabled={!askValue}
                shape="circle"
                icon={<ArrowUpOutlined />}
                onClick={() => {
                  setMenuVisible(false);
                  setAskVisible(false);
                  codeAsk(askValue);
                }}
              />
            </Space>
          )}
        </div>
      </div>
    ),
    [
      menuPosition.top,
      menuPosition.left,
      menuVisible,
      askVisible,
      askValue,
      codeAsk,
    ]
  );
  const editor = useMemo(
    () => (
      <div className={styles.code}>
        <div className={styles.codeHeader}>
          <div className={styles.codeHeaderTitle}>{title}</div>
          {/* <Tooltip placement="bottom" title={"引用"}>
            <Button type="text" icon={<RetweetOutlined />}></Button>
          </Tooltip> */}
        </div>
        <Editor
          height="100%"
          width="100%"
          loading={<Spin indicator={<LoadingOutlined spin />} size="large" />}
          language={language}
          beforeMount={configureEditor}
          onMount={editorDidMount}
          value={text}
          theme={theme === "dark" ? "vs-dark" : "vs"}
          options={{
            readOnly: true,
            contextmenu: true, // 启用右键菜单
            wordWrap: wrap,
          }}
        />

        {/* {renderMenu} */}
      </div>
    ),
    [title, language, editorDidMount, text, theme, wrap]
  );
  const resetState = () => {
    setselectNode([]);
    setExpandedKeys([]);
    setTitle("");
    setText("");
    sNodeData.current = { fileName: "", filePath: "" };
    setMenuVisible(false);
    setAskVisible(false);
    setAskValue("");
    setLoading(false);
    setCodeLoading(false);
    highlightRef.current = {};
  };
  const handleClose = () => {
    resetState();
    close();
  };
  const outSelectFile = (file: {
    openai_file_id?: string;
    original_filename?: string;
    startLine?: number;
    endLine?: number;
  }) => {
    setselectNode([file.openai_file_id || ""]);
    setTitle(file.openai_file_id || "");
    sNodeData.current = {
      fileName: file.openai_file_id || "",
      filePath: file.openai_file_id || "",
    };
    if (file.startLine && file.endLine) {
      const s = Number(file.startLine);
      const e = Number(file.endLine);
      const start = Math.min(s, e);
      const end = Math.max(s, e);
      highlightRef.current = { startLine: start, endLine: end };
    } else {
      highlightRef.current = {};
    }
    getCode(
      file.openai_file_id || "",
      repoData.branch_name,
      repoData.repo_full_name,
      repoData.type
    );
    if ((file.openai_file_id || "").includes("/")) {
      expandToPath(file.openai_file_id || "");
    }
  };
  useImperativeHandle(ref, () => {
    return {
      getTree,
      outSelectFile,
    };
  });
  return !loading ? (
    <div className={styles.repoCodePreview}>
      <div className={styles.repoHeader}>
        <div className={styles.repoTitle}>
          {repoData.repo_full_name}/{repoData.branch_name}
        </div>
        <Space>
          <div className={styles.codeHeaderSwitch}>
            <span style={{ marginRight: 4 }}>自动换行</span>
            <Switch
              checked={wrap === "on"}
              onChange={onWrapChange}
              size="small"
            />
          </div>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={handleClose}
          ></Button>
        </Space>
      </div>
      <div className={styles.repoContent}>
        <Splitter className={styles.chatSplitter}>
          <Splitter.Panel defaultSize={200} min={120} max={350}>
            <div className={styles.menu} ref={menuRef}>
              <DirectoryTree
                className={styles.tree}
                showLine
                showIcon
                switcherIcon={<DownOutlined />}
                treeData={treeData}
                onSelect={onSelect}
                selectedKeys={selectNode}
                loadData={onLoadData}
                expandedKeys={expandedKeys}
                onExpand={(keys) => setExpandedKeys(keys as string[])}
                height={height}
              />
            </div>
          </Splitter.Panel>
          <Splitter.Panel>{editor}</Splitter.Panel>
        </Splitter>
      </div>
    </div>
  ) : (
    <div className={styles.repoCodePreviewLoading}>
      <Spin indicator={<LoadingOutlined spin />} size="large" />
    </div>
  );
}
export default React.forwardRef(Index);
